import { render } from "./QuoteResultClaimSubmission.vue?vue&type=template&id=54622946&scoped=true"
import script from "./QuoteResultClaimSubmission.vue?vue&type=script&lang=js"
export * from "./QuoteResultClaimSubmission.vue?vue&type=script&lang=js"

import "./QuoteResultClaimSubmission.vue?vue&type=style&index=0&id=54622946&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54622946"]])

export default __exports__